(function() {
    const SCRIPT_NAME = 'UpPromote Script v2 (Attribution)';
    console.log(`🔧 ${SCRIPT_NAME} loaded`);

    const NH_LIFETIME_DAYS = 30;
    const NH_AFFILIATE_ID = "7381745";
    const NH_AFFILIATE_HASH = "BMhivuwKscYYb";

    // ✅ Helper function to read cookies
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    // ✅ Helper function to set NH-First-Touch in Local Storage
    function setNHFirstTouch() {
        const expiryDate = new Date();
        expiryDate.setTime(expiryDate.getTime() + (NH_LIFETIME_DAYS * 24 * 60 * 60 * 1000));
        localStorage.setItem('nh_first_touch', JSON.stringify({
            value: 'true',
            expiry: expiryDate.getTime()
        }));
        debugLog(`✅ NH First Touch set in Local Storage with expiry: ${expiryDate}`);
    }

    // ✅ Helper function to check NH-Touch + expiry date
    function hasNHFirstTouch() {
        const nhData = localStorage.getItem('nh_first_touch');
        if (nhData) {
            try {
                const { value, expiry } = JSON.parse(nhData);
                const now = new Date().getTime();

                if (now > expiry) {
                    debugLog(`❌ NH First Touch expired - removing from Local Storage`);
                    localStorage.removeItem('nh_first_touch');
                    return { active: false, expired: true };
                }
                debugLog(`✅ NH First Touch active until: ${new Date(expiry)}`);
                return { active: value === 'true', expired: false };
            } catch (e) {
                debugLog("Error parsing NH First Touch data:", e);
                localStorage.removeItem('nh_first_touch');
                return { active: false, expired: false };
            }
        }
        debugLog(`❌ No NH First Touch found`);
        return { active: false, expired: false };
    }

    // Add new function to set Nature-heart as affiliate
    function setNatureHeartAffiliate() {
        debugLog('🎯 Setting Nature-heart as affiliate');
        
        let attempts = 0;
        const maxAttempts = 10;
        
        function trySetAffiliate() {
            debugLog(`⏰ Attempt ${attempts + 1} to set affiliate...`);
            if (typeof uppromote !== 'undefined') {
                debugLog('✅ Uppromote found, setting tracking...');
                
                // Wenn NH First Touch aktiv ist und ein fremder Affiliate Link existiert
                if (nhStatus.active && hasAffiliateLink && !isNHLink) {
                    debugLog('🧹 Cleaning up web pixel cookies...');
                    clearAffiliateTracking();
                }
                
                // Set initial tracking variables
                uppromote.setLocalTrackingVariables(
                    NH_AFFILIATE_ID,    // affiliate ID
                    false,             // received flag
                    NH_AFFILIATE_HASH,  // hash code
                    new Date().getTime() // current timestamp
                );
                
                // Then do the tracking call
                uppromote.postClickTracking({
                    aid: NH_AFFILIATE_ID,
                    hc: NH_AFFILIATE_HASH,
                    s: uppromote.getShopName(),
                    ug: navigator.userAgent
                }, null, (response) => {
                    debugLog('📡 Got response from tracking call:', response);
                    if (response.status === 'ok') {
                        debugLog('✅ Successfully attributed visit to Nature-heart');
                        debugLog('📝 Cookies set:', document.cookie);
                        debugLog('💾 LocalStorage scaaf_aid:', localStorage.getItem('scaaf_aid'));
                    } else {
                        debugLog('❌ Failed to set Nature-heart affiliate:', response);
                    }
                });
            } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(trySetAffiliate, 1000);
                debugLog('⏳ Uppromote not ready, will retry...');
            } else {
                debugLog('❌ Failed to find Uppromote after max attempts');
            }
        }
        
        trySetAffiliate();
    }

    // Neue Helper Funktion
    function isNatureHeartAffiliateLink(urlParams) {
        const scaRef = urlParams.get('sca_ref');
        if (!scaRef) return false;
        
        // Prüfe ob der Link von NH ist
        const [affiliateId] = scaRef.split('.');
        return affiliateId === NH_AFFILIATE_ID;
    }

    // Modify the main logic section
    const nhStatus = hasNHFirstTouch();
    const urlParams = new URLSearchParams(window.location.search);
    const hasAffiliateLink = urlParams.has('sca_ref');
    const isNHLink = isNatureHeartAffiliateLink(urlParams);
    const hasExistingAffiliateCookie = !!getCookie('scaaf_aid');

    debugLog('👉 State:', { 
        hasAffiliateLink,
        isNHLink, 
        hasExistingAffiliateCookie,
        nhFirstTouch: nhStatus 
    });

    let shouldAttributeToNatureHeart = false;

    if (nhStatus.active) {
        // NH First Touch ist aktiv → IMMER NH Attribution
        debugLog('🎯 NH First Touch active → Force NH Attribution');
        shouldAttributeToNatureHeart = true;
        
        if (hasAffiliateLink && !isNHLink) {
            // Fremde Affiliate Links blockieren
            debugLog('⚠️ Blocking non-NH affiliate link due to active NH First Touch');
            clearAffiliateTracking();
        }
    } else if (!hasExistingAffiliateCookie && !hasAffiliateLink) {
        // Direkter Besuch ohne Cookies/Links → Neuer First Touch
        debugLog('👉 Direct visit → Setting NH First Touch');
        setNHFirstTouch();
        shouldAttributeToNatureHeart = true;
    } else {
        debugLog('✅ Allowing normal affiliate tracking');
    }

    if (shouldAttributeToNatureHeart) {
        debugLog('🎯 Setting Nature-heart as affiliate');
        setNatureHeartAffiliate();
    }

    function clearAffiliateTracking() {
        // Get all cookies
        const cookies = document.cookie.split(';');
        
        // Clear all up_uppromote_* cookies
        cookies.forEach(cookie => {
            const cookieName = cookie.split('=')[0].trim();
            if (cookieName.startsWith('up_uppromote_')) {
                debugLog('🧹 Clearing cookie:', cookieName);
                document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            }
        });
        
        // Clear URL parameters
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('sca_ref');
        cleanUrl.searchParams.delete('sca_source');
        window.history.replaceState({}, '', cleanUrl);
    }
})();